module.exports = __webpack_public_path__ + "static/media/10.c55a0b4c.mp3";